<template>
    <div v-show="assetValue" class="mx-2 my-3 text-center">
        <p class="font-bold uppercase text-xs text-gray-500">{{ assetPropety }}</p>
        <p> {{ assetValue }} </p>
    </div>
</template>

<script>
export default {
    name: 'DeviceProperty',
    props: [
        'assetPropety',
        'assetValue'
    ],
    data() {
        return {};
    }
}
</script>